// @ helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    PRODUCT_TYPE_FUND,
    PRODUCT_TYPE_FUND_UPGRADED,
    PRODUCT_TYPE_PLAN,
    PRODUCT_TYPE_PLAN_UPGRADED,
    BROKER_FAVORITE_MAX_PRODUCT_SIZE
} = require('constants/index');
const fundOrPlanTypes = [PRODUCT_TYPE_FUND, PRODUCT_TYPE_FUND_UPGRADED, PRODUCT_TYPE_PLAN, PRODUCT_TYPE_PLAN_UPGRADED];

// @ actions
const notification = require('actions/notifications');

const getWatchlistRequest = () => ({
    type: actionTypes.BROKER_GET_WATCHLIST_REQUEST
});

const watchlistSuccess = (data) => ({
    type: actionTypes.BROKER_GET_WATCHLIST_SUCCESS,
    payload: {
        data
    }
});

const watchlistFailure = () => ({
    type: actionTypes.BROKER_GET_WATCHLIST_FAILURE
});

const saveListName = (listName) => ({
    type: actionTypes.BROKER_SAVE_LIST_NAME,
    payload: {
        listName
    }
});

const createNewList = () => ({
    type: actionTypes.BROKER_CREATE_NEW_LIST
});

const watchlistModalToggle = (value) => ({
    type: actionTypes.BROKER_WATCHLIST_MODAL_TOGGLE,
    payload: {
        value
    }
});

const resetWatchlistDetails =() => ({
    type: actionTypes.BROKER_WATCHLIST_RESET
});

const getUserWatchlist = () => (dispatch) => {

    dispatch(getWatchlistRequest());

    return APIGet({ dispatch, endpoint: 'userWatchlist' })
        .then(response => {
            return dispatch(watchlistSuccess(response));
        })
        .catch(response => {
            return dispatch(watchlistFailure(response.error));
        });
};

const deletetWatchlistRequest = () => ({
    type: actionTypes.BROKER_DELETE_WATCHLIST_REQUEST
});

const deletetWatchlistSuccess = (data, listId) => ({
    type: actionTypes.BROKER_DELETE_WATCHLIST_SUCCESS,
    payload: {
        data,
        listId
    }
});

const deletetWatchlistFailure = error => ({
    type: actionTypes.BROKER_DELETE_WATCHLIST_ERROR,
    payload: { error }
});

const deleteWatchList = (listId) => (dispatch, getState) => {
    dispatch(deletetWatchlistRequest());
    const brokerWatchlist = getState().brokerWatchlist;
    const list = brokerWatchlist.get('watchlistContent').find(list => list.get('id') === listId);
    const listName = list && list.get('name');
    return APIPost(dispatch, apiURLBuilder.getURL('deleteWatchlist', { id: listId }))
        .then(response => {
            const message = formatText('brokerWatchList-brokerWatchList_deleteListSuccess', [listName]);
            dispatch(notification.success({message}, {voice: message}));
            return dispatch(deletetWatchlistSuccess(response, listId));
        })
        .catch(errorObj => {
            return dispatch(deletetWatchlistFailure(errorObj.error));
        });
};

const deleteProductFromListRequest = () => ({
    type: actionTypes.BROKER_DELETE_PRODUCT_FROM_LIST_REQUEST,
});

const deleteProductFromListError = (error) => ({
    type: actionTypes.BROKER_DELETE_PRODUCT_FROM_LIST_ERROR,
    payload: {
        error
    }
});

const deleteProductFromListSuccess = (response, editListId, isin, status) => ({
    type: actionTypes.BROKER_DELETE_PRODUCT_FROM_LIST_SUCCESS,
    payload: {
        response,
        editListId,
        isin,
        status
    }
});

const updateWatchlistId = (productKey, watchlistId = null) => ({
    type: actionTypes.BROKER_WATCHLIST_ID_UPDATE,
    payload: {
        productKey,
        watchlistId
    }
});

const deleteProductFromList = (id, isin, micCode, productName, status, deleteProductLandingMsg, productType, productKey ) => (dispatch, getState) => {
    let deleteWatchlistProductEndPoint, requestParams;
    const selectedProductKey = productKey;
    const brokerWatchlist = getState().brokerWatchlist;
    const list = brokerWatchlist.get('watchlistContent').find(list => list.get('id') === id);
    const listName = list && list.get('name');
    const productTypeFormatted = productType.toLowerCase();
    if (fundOrPlanTypes.includes(productTypeFormatted)) { //For plans and funds endPoints are different and give only ISIN to API
        deleteWatchlistProductEndPoint = 'deleteFundsPlansFromList';
        requestParams = {
            id,
            isin
        }
    } else {
        deleteWatchlistProductEndPoint = 'deleteProductFromList';
        requestParams = {
            id,
            isin,
            micCode
        }
    }
    const deleteProductSnackBarMsg = deleteProductLandingMsg ? 'brokerWatchList-brokerWatchList_deleteLandingProductListSuccess' : 'brokerWatchList-brokerWatchList_deleteSearchProductListSuccess';
    dispatch(deleteProductFromListRequest());
    return APIPost(dispatch, apiURLBuilder.getURL(deleteWatchlistProductEndPoint, requestParams))
        .then(response => {
            const message = formatText(deleteProductSnackBarMsg, [listName]);
            if(!deleteProductLandingMsg) {
                dispatch(updateWatchlistId(selectedProductKey));
                dispatch(getUserWatchlist());
                dispatch(notification.success({message, actionText: formatText('brokerWatchList-brokerWatchList_seeListText'), actionLink: `/myprofile/broker/watchlist/${id}`}, {voice: message}));
            } else {
                dispatch(notification.success({message}, {voice: message}));
            }
            dispatch(deleteProductFromListSuccess(response, id, isin, status));
        }).catch(error => {
            dispatch(deleteProductFromListError(error))
        });
};

const editWatchListProgress = () => ({
    type: actionTypes.BROKER_EDIT_WATCHLIST_NAME_IN_PROGRESS
});

const editWatchListError = (error) => ({
    type: actionTypes.BROKER_EDIT_WATCHLIST_NAME_ERROR,
    payload: {
        error
    }
});

const editWatchListSuccess = (name, listId, products) => ({
    type: actionTypes.BROKER_EDIT_WATCHLIST_NAME,
    payload: {
        name,
        listId,
        products
    }
});

const requestEditWatchList = (name, listData, immProducts) => (dispatch) => {
    dispatch(editWatchListProgress());
    const requestParams = {
        query: {
            name,
            productsToRemove: [],
            productsToAdd: []
        }
    };
    const listId = listData.get('id');
    const productsFinal = listData.get('products');
    
    if (!!immProducts) {
        immProducts.forEach((product) => {
            const isin = product.get('isin');
            const _product = productsFinal.find((product) => {
                return product.get('isin') === isin;
            });
            //If status has been changed then only add or remove it.
            if (!!_product && _product.get('unChecked') !== product.get('unChecked')) {
                if (product.get('unChecked')) {
                    requestParams.query.productsToRemove.push({
                        isin: product.get('isin'),
                        micCode: product.get('micCode')
                    });
                } else {
                    requestParams.query.productsToAdd.push({
                        isin: product.get('isin'),
                        micCode: product.get('micCode')
                    });
                }
            }
        });
    }

    return APIPost(dispatch, apiURLBuilder.getURL('specificWatchlist', { id: listId }), requestParams)
        .then((response) => {
            const message = formatText('brokerWatchList-brokerWatchList_editListSuccess');
            dispatch(notification.success({message}, {voice: message}));
            dispatch(editWatchListSuccess(name, listId, immProducts, response));
        }).catch((error) => {
            dispatch(editWatchListError(error));
        });
};

const sortWatchList = (sortBy, id, order) => ({
    type: actionTypes.BROKER_WATCHLIST_SORT,
    payload: {
        sortBy,
        id,
        order
    }
});

const addToExistingList = (id, isin, micCode, listName, productType, addProductFromLandingPage) => (dispatch, getState) => {
    let selectedProductKey;
    let endPoint, endPointParams, selectedListDetails;
    const watchlistId = id;
    if (addProductFromLandingPage) { //Add Product from Landing of watchlist
        const productTypeFormatted = productType.toLowerCase();
        endPoint = fundOrPlanTypes.includes(productTypeFormatted) ? 'addFundsPlansToExistingWatchlist' :  'addProductToExistingWatchlist';  //For plans and funds endPoints are different and give only ISIN to API
        endPointParams = fundOrPlanTypes.includes(productTypeFormatted) ? {id, isin} : {id, isin, micCode};
    } else { //Add Product From Search
        const productDetails = getState().brokerWatchlist.get('savedProductDetails');
        const selectedId = getState().brokerWatchlist.get('listSelectedId') || id;
        selectedListDetails = getState().brokerWatchlist.get('watchlistContent').find((item) => item.get('id') === parseInt(selectedId));
        selectedProductKey = productDetails.saveProductKey;
        const micCode = !productDetails.miccode ? productDetails.saveMiccode : productDetails.miccode;
        productType = productDetails.saveProductType;
        const productTypeFormatted = productType.toLowerCase();
        let isin = !productDetails.isin ? productDetails.saveIsin : productDetails.isin;
        endPoint = fundOrPlanTypes.includes(productTypeFormatted) ? 'addFundsPlansToExistingWatchlist' :  'addProductToExistingWatchlist';  //For plans and funds endPoints are different and give only ISIN to API
        endPointParams = fundOrPlanTypes.includes(productTypeFormatted) ? {id, isin} : {id, isin, micCode};
        dispatch(watchlistModalToggle(true));
        if (selectedListDetails.get('productsCount') === BROKER_FAVORITE_MAX_PRODUCT_SIZE) {
            const message = formatText('brokerWatchList-brokerWatchlist_maxProductErrorMessage');
            return dispatch(notification.error({message}, {voice: message}));
        }
    }
    return APIPost(dispatch, apiURLBuilder.getURL(endPoint, endPointParams))
        .then((response) => {
            let message;
            if (addProductFromLandingPage){
                message = formatText('brokerWatchList-brokerWatchList_addListSuccess', [listName]);
            } else {
                dispatch(getUserWatchlist());
                dispatch(updateWatchlistId(selectedProductKey, response.watchlist.id));
                message = formatText('brokerWatchList-brokerWatchList_addListSuccess', [selectedListDetails.get('name')]);
            }
            dispatch(notification.success({message, actionText: formatText('brokerWatchList-brokerWatchList_seeListText'), actionLink: `/myprofile/broker/watchlist/${watchlistId}`}, {voice: message}));
        });

};

const listSelected = (id) => ({
    type: actionTypes.BROKER_WATCHLIST_SELECTED_LIST,
    payload: {
        id
    }
});

const listSelectedForParam = (id) => ({
    type: actionTypes.BROKER_WATCHLIST_SELECTED_LIST_FOR_PARAM,
    payload: {
        id
    }
});

const productDetailsToList = (isin, micCode, productType, productKey) => ({
    type: actionTypes.BROKER_WATCHLIST_SAVE_PRODUCT_DETAILS,
    payload: {
        isin,
        micCode,
        productType,
        productKey
    }
});

const addProductToWatchlist = (data) => ({
    type: actionTypes.BROKER_WATCHLIST_ADDED,
    payload: {
        data
    }
});

const createNewListName = () =>(dispatch, getState) => {
    const listName = getState().brokerWatchlist.get('listName');
    const data = {query:  {"name": listName, "products": [], "id":''}};

    return APIPost(dispatch, apiURLBuilder.getURL('userWatchlist'), data)
        .then((response) => {
            data.query.id = response.watchlist.id;
            const message = formatText('brokerWatchList-brokerWatchList_newListSuccess', [listName]);
            dispatch(addProductToWatchlist(data));
            dispatch(watchlistModalToggle(true));
            dispatch(getUserWatchlist());
            dispatch(notification.success({message, actionText: formatText('brokerWatchList-brokerWatchList_seeListText'), actionLink: `/myprofile/broker/watchlist/${data.query.id}`}, {voice: message}));
        });
};

const newListName = () => (dispatch, getState) => {
    const listName = getState().brokerWatchlist.get('listName');
    const productDetails = getState().brokerWatchlist.get('savedProductDetails');
    const isin = !productDetails.isin ? productDetails.saveIsin : productDetails.isin;
    const micCode = !productDetails.miccode ? productDetails.saveMiccode : productDetails.miccode;
    const selectedProductKey = productDetails.saveProductKey;
    const data = {query:  {"name": listName}};

    return APIPost(dispatch, apiURLBuilder.getURL('addProductToNewWatchlist', {isin, micCode}), data)
        .then((response) => {
            const listId = response.watchlist.id;
            const message = formatText('brokerWatchList-brokerWatchList_createListSuccess', [listName,listId]);
            dispatch(watchlistModalToggle(true));
            dispatch(updateWatchlistId(selectedProductKey, response.watchlist.id));
            dispatch(getUserWatchlist());
            dispatch(notification.success({message, actionText: formatText('brokerWatchList-brokerWatchList_seeListText'), actionLink: `/myprofile/broker/watchlist/${listId}`}, {voice: message}));
        });
};

module.exports = {
    addToExistingList,
    createNewList,
    createNewListName,
    deleteProductFromList,
    deleteWatchList,
    getUserWatchlist,
    listSelected,
    listSelectedForParam,
    newListName,
    productDetailsToList,
    requestEditWatchList,
    resetWatchlistDetails,
    saveListName,
    sortWatchList,
    watchlistModalToggle,
};
